/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S5_P2Inputs */

const en_guide_what_is_json_s5_p2 = /** @type {(inputs: Guide_What_Is_Json_S5_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For debugging API responses, a <a href="/">JSON viewer</a> with tree navigation helps you explore deeply nested structures without getting lost. You can expand and collapse sections to focus on the data you need.`)
};

const ko_guide_what_is_json_s5_p2 = /** @type {(inputs: Guide_What_Is_Json_S5_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 응답을 디버깅할 때는 트리 탐색 기능이 있는 <a href="/">JSON 뷰어</a>가 깊이 중첩된 구조를 탐색하는 데 도움이 됩니다. 섹션을 펼치고 접어서 필요한 데이터에 집중할 수 있습니다.`)
};

const ja_guide_what_is_json_s5_p2 = /** @type {(inputs: Guide_What_Is_Json_S5_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIレスポンスのデバッグには、ツリーナビゲーション付きの<a href="/">JSONビューアー</a>が深くネストされた構造の探索に役立ちます。セクションを展開・折りたたみして、必要なデータに集中できます。`)
};

/**
* | output |
* | --- |
* | "For debugging API responses, a <a href=\"/\">JSON viewer</a> with tree navigation helps you explore deeply nested structures without getting lost. You can expa..." |
*
* @param {Guide_What_Is_Json_S5_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s5_p2 = /** @type {((inputs?: Guide_What_Is_Json_S5_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S5_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s5_p2(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s5_p2(inputs)
	return ja_guide_what_is_json_s5_p2(inputs)
});